module.exports = __webpack_public_path__ + "static/amazon-appstore-badge-de-white-73455ace317ff66e5ca918a0093db912.svg";